// extracted by mini-css-extract-plugin
module.exports = {"list_menu":"list_menu-2g1cRU0C","morehNew":"morehNew-2sKAV_oa","more":"more-PCY12DbE"};